module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zuLSa0/tc-custom/9781541546530.jpg?1718184632334",
      "alt": "This image is the cover for the book Jane Doe and Cradle of All Worlds, The Jane Doe Chronicles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jane Doe and Cradle of All Worlds, The Jane Doe Chronicles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("John Doe and his infant daughter, Jane, appeared on the steps of the Manor the night the earthquakes started and the gateway to the Otherworlds closed. The people on the remote island of Bluehaven have despised them ever since, blaming Jane and her father for their exile. Fourteen years after that night, the largest earthquake yet strikes. The Manor awakens, dragging John into its labyrinth. Accompanied by a pyromaniac named Violet and a trickster named Hickory, Jane must rescue her father and defeat an immortal villain who is trying to harness the mythical power of the Manor.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeremy Lachlan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Carolrhoda Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0